<template>
  <v-dialog v-model="otpRequireDialogModel" max-width="600" persistent>
    <v-card flat class="otp-require-dialog">
      <v-card-title class="justify-center">
        Set up two-factor authentication
      </v-card-title>
      <v-card-text>
        <v-alert type="info" text>
          In our commitment to security, we require two-factor authentication (2FA) for all users.
          This adds an extra layer of protection to your account. Please set up 2FA using an authenticator app like 1Password, Google Authenticator or Microsoft Authenticator.
        </v-alert>
        <div class="text-center">
          <v-btn color="primary" @click="pushToAddAuthenticator">
            Add Authenticator
          </v-btn>
          <br>
          <v-btn
            x-small
            text
            color="primary"
            class="otp-require-dialog__continue-btn"
            @click="otpRequireDialogModel = false"
          >
            Continue without 2FA
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { mapMutations, mapState } from 'vuex';
import mixins from 'vue-typed-mixins';

import { RootMutations } from '@/store/types/mutation-types';
import { AccountLayoutMixin } from '@/bundles/App/mixins/accountMixin';

export default mixins(AccountLayoutMixin).extend({
  name: 'OTPRequireDialog',

  computed: {
    ...mapState({
      otpRequireDialog: (state: any) => state.otpRequireDialog,
    }),
    otpRequireDialogModel: {
      get (): boolean {
        return this.otpRequireDialog;
      },
      set (value: boolean) {
        this.changeOtpRequireDialog(value);
      }
    }
  },

  methods: {
    ...mapMutations({
      changeOtpRequireDialog: RootMutations.CHANGE_OTP_REQUIRE_DIALOG
    }),
    pushToAddAuthenticator () {
      this.changeOtpRequireDialog(false);
      this.$router.push(this.getAccountRoute({ name: 'user-security' }));
    }
  }
})
</script>

<style scoped lang="scss">
.otp-require-dialog__continue-btn {
  margin-top: 8px;
  padding: 0 !important;
  height: auto !important;
  transition: all 0.2s ease-in-out !important;

  &:hover {
    font-weight: 800 !important;
  }

  &:before {
    background: none !important;
  }
}
</style>
